var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50003 1H6.50003L3.99503 4.15L1.50003 1ZM0.125028 0.805C1.13503 2.1 3.00003 4.5 3.00003 4.5V7.5C3.00003 7.775 3.22503 8 3.50003 8H4.50003C4.77503 8 5.00003 7.775 5.00003 7.5V4.5C5.00003 4.5 6.86003 2.1 7.87003 0.805C8.12503 0.475 7.89003 0 7.47503 0H0.520028C0.105028 0 -0.129972 0.475 0.125028 0.805Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter8);
export default __webpack_public_path__ + "97120/static/media/filter8.fa49666f5b52f373d7a8432d228f0077.svg";
export { ForwardRef as ReactComponent };